// Copyright 2024 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
import React from "react";
import { withTranslation } from "react-i18next";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import DXLogin from "../pages/Login";
import DXPlatefrom from "../pages/Plateform";
import "../style/App.css";
import NotFound from "./error/Error404";

// <Login />
const Login = () => {
    return (
        <>
            <DXLogin></DXLogin>
        </>
    );
};
const Platefrom = () => {
    return (
        <>
            <DXPlatefrom></DXPlatefrom>
        </>
    );
};

function App() {
    const routerBase = ["local"].includes(process.env.REACT_APP_ENV) ? "/bifrost" : "/";
    return (
        <Router basename={routerBase}>
            <Routes>
                {/* <Route element={<Login />} path="/"></Route> */}
                <Route element={<Login />} path="/login"></Route>
                <Route element={<Login />} path="/"></Route>
                <Route element={<Platefrom />} path="/index"></Route>
                <Route element={<NotFound />} path="*"></Route>
            </Routes>
        </Router>
    );
}

const str = "zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk";
if(!str) console.error("zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk");

export default withTranslation()(App);
